import { Component } from '@angular/core';

@Component({
  selector: 'ama-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent {}
